import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";

function DocumentCollectionEnabledWarning() {
  return (
    <div className="flex gap-x-2 items-center">
      <ExclamationCircleIcon className="text-blue-500 size-4" />
      <p className="font-xs text-xs text-blue-500">
        Responses are delayed by a minimum of 20 seconds
      </p>
    </div>
  );
}

function DocumentCollectionDisabledWarning() {
  return (
    <div className="flex gap-x-2 items-center">
      <ExclamationTriangleIcon className="text-orange-500 size-4" />
      <p className="font-xs text-xs text-orange-500">
        If enabled, responses will be delayed by 20 seconds minimum
      </p>
    </div>
  );
}

export default function DocumentCollectionDelayWarning(props) {
  const { isEnabled } = props;

  if (isEnabled) {
    return <DocumentCollectionEnabledWarning />;
  }

  return <DocumentCollectionDisabledWarning />;
}
